import React from "react";
import { CollectionNavigation } from "../../components/OneRowChrome.jsx";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useFeatureFlagContext } from "../../contexts/FeatureFlagContext.jsx";
import { enabledPlacesLenses, resolvePlacesLens } from "../../app/places.js";
import { governedNavEnabled } from "../../app/governedNav.js";
import { ChromeTab } from "../../components/ObjectChrome.jsx";
import { normalizeCapacitySearch } from "../capacity/capacityUrl.js";
import "./places.css";

export function PlacesFrame({ lens, fallbackPath, children }) {
  const { flags, flagsReady, nav_config, nav_order, placesTabs } = useFeatureFlagContext();
  const location = useLocation();
  const navigate = useNavigate();
  const target = resolvePlacesLens(lens, placesTabs);
  const parentEnabled = governedNavEnabled(flags, nav_config, "places", nav_order);

  if (flagsReady === false) return null;
  if (!parentEnabled || !target) return <Navigate to={fallbackPath} replace />;
  if (target !== lens) return <Navigate to={`/places/${target}${location.search}${location.hash}`} state={location.state} replace />;
  return (
    <div className="places-object" data-places-lens={lens}>
      <CollectionNavigation>
      <nav className="places-subnav object-subnav-tabs" aria-label="Places">
        {enabledPlacesLenses(placesTabs).map((tab) => (
          <ChromeTab key={tab.key} type="button" active={lens === tab.lens}
            aria-current={lens === tab.lens ? "page" : undefined}
            onClick={() => navigate(`/places/${tab.lens}${location.search}${location.hash}`)}>
            {tab.label}
          </ChromeTab>
        ))}
      </nav>
      </CollectionNavigation>
      <div className="places-collection-content">{children}</div>
    </div>
  );
}

// Exact list aliases only. Record URLs remain owned by their existing routes.
export function PlacesAlias({ lens }) {
  const location = useLocation();
  return <Navigate to={`/places/${lens}${location.search}${location.hash}`} state={location.state} replace />;
}

// Retired Pressure/Scenario collection URLs: keep meaningful query state,
// drop retired controls (horizon/basis/layer), and open the Scenario panel
// for old Scenario links.
export function CapacityRedirect({ fromLens = null }) {
  const location = useLocation();
  return <Navigate to={`/places/capacity${normalizeCapacitySearch(location.search, { fromLens })}${location.hash}`} state={location.state} replace />;
}
